import React, { useCallback, useEffect, useState } from 'react';
import { fetchTransportList } from '../../../services/transport';
import { toast } from 'react-toastify';

function useTransport() {
	const [transportList, setTransportList] = useState([]);
	const [searchTransport, setSearchTransport] = useState('');
	const [transportParams, setTransportParams] = useState({
		page: 1,
		limit: 20,
		search: '',
	});

	const handleFetchTransportList = useCallback(async () => {
		try {
			const data = await fetchTransportList(transportParams);
			const transportOptionList = data?.transports?.map((t) => {
				return {
					key: t?.transport_name,
					value: t?.transport_name,
				};
			});
			setTransportList(transportOptionList);
		} catch (error) {
			toast.error('Something went wrong! While Fetching the Transport list.');
		}
	}, [transportParams]);

	useEffect(() => {
		handleFetchTransportList();
	}, [transportParams?.search]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setTransportParams((prev) => ({
				...prev,
				search: searchTransport,
			}));
		}, 500);
		return () => clearTimeout(timer);
	}, [searchTransport]);

	return { transportList, setTransportList, setTransportParams, setSearchTransport };
}

export default useTransport;
